/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Dictionary extends React.Component {
  render() {
    return <div>
        {this.props.children}
    </div>
  }
};
export default Dictionary;


// WEBPACK FOOTER //
// ./src/routes/dictionary/index.js